'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n'], ['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-style: dashed;\n  border-width: 2px;\n  border-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-style: dashed;\n  border-width: 2px;\n  border-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-width: 300px;\n  padding: 10px;\n  margin: auto;\n'], ['\n  width: 100%;\n  max-width: 300px;\n  padding: 10px;\n  margin: auto;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 20px;\n'], ['\n  width: 100%;\n  height: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Heading = require('../../Heading/Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _SimpleMenu = require('../../SimpleMenu/SimpleMenu');

var _SimpleMenu2 = _interopRequireDefault(_SimpleMenu);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject);

var Border = _styledComponents2.default.div(_templateObject2, _colors.grey);

var Content = _styledComponents2.default.div(_templateObject3);

var ButtonContainer = _styledComponents2.default.div(_templateObject4);

var Separator = _styledComponents2.default.div(_templateObject5);

var TypeSelector = function (_Component) {
  _inherits(TypeSelector, _Component);

  function TypeSelector() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeSelector);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeSelector.__proto__ || Object.getPrototypeOf(TypeSelector)).call.apply(_ref, [this].concat(args))), _this), _this.data = function () {
      var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.types;
      return [].concat(_toConsumableArray(types)).filter(function (_ref2) {
        var uploadable = _ref2.uploadable,
            folders = _ref2.folders;
        return uploadable || !!folders;
      }).map(function (type) {
        var data = {
          value: type.key,
          label: type.name
        };
        if (!!type.folders) data.options = _this.data(type.folders);
        return data;
      });
    }, _this.onSelect = function (val) {
      var _this$props = _this.props,
          types = _this$props.types,
          onType = _this$props.onType;
      var flatTypes = [].concat(_toConsumableArray(types)).reduce(function (combined, type) {
        return !!type.folders ? [].concat(_toConsumableArray(combined), _toConsumableArray(type.folders)) : [].concat(_toConsumableArray(combined), [type]);
      }, []);
      var type = [].concat(_toConsumableArray(flatTypes)).find(function (type) {
        return type.key === val;
      });
      if (!type) return;
      onType(type);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeSelector, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          small = _props.small,
          onCancel = _props.onCancel;
      return _react2.default.createElement(Container, null, _react2.default.createElement(Border, null, _react2.default.createElement(Content, null, _react2.default.createElement(_Heading2.default, {
        size: small ? '4' : '2'
      }, 'Document type'), _react2.default.createElement(Separator, null), _react2.default.createElement(_SimpleMenu2.default, {
        options: this.data(),
        onSelect: this.onSelect,
        open: 'all'
      }), _react2.default.createElement(Separator, null), _react2.default.createElement(ButtonContainer, null, _react2.default.createElement(_Button2.default, {
        size: 'small',
        theme: 'grey',
        onClick: onCancel
      }, 'Back')))));
    }
  }]);

  return TypeSelector;
}(_react.Component);

TypeSelector.propTypes = {
  types: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    attributes: _propTypes2.default.bool,
    folders: _propTypes2.default.array,
    uploadable: _propTypes2.default.bool
  })),
  onType: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  small: _propTypes2.default.bool
};
TypeSelector.defaultProps = {
  types: [],
  onType: function onType() {
    return null;
  }
};
exports.default = TypeSelector;